export const SET_SEARCH_PARAMS = 'SET_SEARCH_PARAMS';
export const SET_FLIGHT_TYPE = 'SET_FLIGHT_TYPE';
export const SET_CABIN = 'SET_CABIN';
export const SET_PASSEGERS = 'SET_PASSEGERS';
export const SET_ROUTES = 'SET_ROUTES';
export const SET_HAS_DATA = 'SET_HAS_DATA';
export const SET_NOT_FILLED_FIELDS = 'SET_NOT_FILLED_FIELDS';
